export default [
    {
        "year": 1985,
        "question": "Why do you keep____ your eyes（）",
        "A": "rub",
        "B": "rubbing",
        "C": "rubbed",
        "D": "to rub",
        "answer": "B"
    },
    {
        "year": 1986,
        "question": "__turn greenin spring（）",
        "A": "Leaf",
        "B": "Leafs",
        "C": "Leave",
        "D": "Leaves",
        "answer": "D"
    },
    {
        "year": 1987,
        "question": "Father went to his doctor for ___about his heart trouble.",
        "A": "an advice",
        "B": "advice",
        "C": "advices",
        "D": "the advices",
        "answer": "B"
    },
    {
        "year": 1988,
        "question": "As it was a stormy night,_____people went to see the film.",
        "A": "a few",
        "B": "few",
        "C": "several",
        "D": "many",
        "answer": "B"
    },
    {
        "year": 1989,
        "question": "Does John know any other foreign language _____ French（）",
        "A": "except",
        "B": "but",
        "C": "besides",
        "D": "beside",
        "answer": "B"
    },
    {
        "year": 1990,
        "question": "Not until I began to work____ how much time I had wasted（）",
        "A": "didn't I realize",
        "B": "did I realize",
        "C": "I didn't realize",
        "D": "I realized",
        "answer": "B"
    },
    {
        "year": 1991,
        "question": "Don't smoke in the meeting-room（）",
        "A": "do you",
        "B": "will you",
        "C": "can you",
        "D": "could you",
        "answer": "A"
    },
    {
        "year": 1992,
        "question": "一lusually go there by train.一Why not_____by boat for a change?（）",
        "A": "to try going",
        "B": "trying togo",
        "C": "to try and go",
        "D": "try going",
        "answer": "D"
    },
    {
        "year": 1993,
        "question": "If no one ____ the phone at home，ring me at work（）",
        "A": "returns",
        "B": "replies",
        "C": "answers",
        "D": "recei ves",
        "answer": "C"
    },
    {
        "year": 1994,
        "question": "—Do you remember ______ he came? —Yes, I do, he came by car.",
        "A": "how",
        "B": "when",
        "C": "that",
        "D": "if",
        "answer": "A"
    },
    {
        "year": 1995,
        "question": "Paul doesn't have to be made _____.He always works hard.",
        "A": "learn",
        "B": "to learn",
        "C": "learned",
        "D": "learning",
        "answer": "B"
    },
    {
        "year": 1996,
        "question": "_____we can 't get seems better than______we have（）",
        "A": "What;what",
        "B": "What;that",
        "C": "That;that",
        "D": "That;what",
        "answer": "A"
    },
    {
        "year": 1997,
        "question": "It is generally considered unwise to give a child ______ he or she wants.",
        "A": "however",
        "B": "whatever",
        "C": "whichever",
        "D": "whenever",
        "answer": "B"
    },
    {
        "year": 1998,
        "question": "l hate_____when people talk with their mouths full（ ）",
        "A": "it",
        "B": "that",
        "C": "these",
        "D": "them",
        "answer": "D"
    },
    {
        "year": 1999,
        "question": "___him and then try to copy what he does.",
        "A": "Mind",
        "B": "Glance",
        "C": "Stare at",
        "D": "Watch",
        "answer": "D"
    },
    {
        "year": 2000,
        "question": "I don’t think I’ll need any money but I’ll bring some ____",
        "A": "at last",
        "B": "in case",
        "C": "once again",
        "D": "in time",
        "answer": "B"
    },
    {
        "year": 2001,
        "question": "As we joined the big crowd I got ____ from my friends .",
        "A": "separated",
        "B": "spared",
        "C": "lost",
        "D": "missed",
        "answer": "A"
    },
    {
        "year": 2002,
        "question": "Boris has brains. In fact,I doubt whether anyone in the class has _____IQ（）",
        "A": "a high",
        "B": "a highter",
        "C": "the higher",
        "D": "the highest",
        "answer": "B"
    },
    {
        "year": 2003,
        "question": "Don’t be afraid of asking for help _____it is needed.",
        "A": "unless",
        "B": "since",
        "C": "although",
        "D": "whenever",
        "answer": "D"
    },
    {
        "year": 2004,
        "question": "Let’s keep to the point or we ______ any decisions.",
        "A": "will never reach",
        "B": "have never reached",
        "C": "never reach",
        "D": "never reached",
        "answer": "A"
    },
    {
        "year": 2005,
        "question": "No one helped me. I did it all ____myself.",
        "A": "for",
        "B": "by",
        "C": "from",
        "D": "to rub",
        "answer": "B"
    },
    {
        "year": 2006,
        "question": "Eliza remembers everything exactly as if it ____yesterday.",
        "A": "was happening",
        "B": "happens",
        "C": "has happened",
        "D": "happened",
        "answer": "D"
    },
    {
        "year": 2007,
        "question": "I won’t call you, _____ something unexpected happens.",
        "A": "unless",
        "B": "whether",
        "C": "because",
        "D": "while",
        "answer": "A"
    },
    {
        "year": 2008,
        "question": "The performance ____nearly three hours, but few people left the theatre early. ",
        "A": "covered",
        "B": "reached",
        "C": "played",
        "D": "lasted",
        "answer": "D"
    },
    {
        "year": 2009,
        "question": "It looks heavy. Can I give you a hand （）",
        "A": "No,thanks",
        "B": "Yes, my pleasure",
        "C": "No,never mind",
        "D": "Yes, I do",
        "answer": "B"
    },
    {
        "year": 2010,
        "question": "Mrs.White showed her students some old maps____ from the library.",
        "A": "to borrow",
        "B": "to be borrowed",
        "C": "borrowed",
        "D": "borrowing",
        "answer": "C"
    },
    {
        "year": 2011,
        "question": "If you ____smoke, please go outside.",
        "A": "can",
        "B": "should",
        "C": "must",
        "D": "may",
        "answer": "C"
    },
    {
        "year": 2012,
        "question": "Which one of these do you want?__Either will do （）",
        "A": "I don't mind",
        "B": "I'm sure",
        "C": "No problem",
        "D": "Go ahead",
        "answer": "A"
    },
    {
        "year": 2013,
        "question": "Would you like to____with us to the film tonight?",
        "A": "come along",
        "B": "come off",
        "C": "come across",
        "D": "come through",
        "answer": "A"
    },
    {
        "year": 2014,
        "question": "It’s so nice to hear from her again_____,we last met more than thrity years age（） ",
        "A": "What＇s more",
        "B": "That＇s to say",
        "C": "In other words",
        "D": "Believe it or not",
        "answer": "D"
    },
    {
        "year": 2015,
        "question": "_____the early flight，we ordered a taxi in advance and got up very early.",
        "A": "Catching",
        "B": "Caught",
        "C": "To catch",
        "D": "Catch",
        "answer": "C"
    },
    {
        "year": 2016,
        "question": " I am not afraid of tomorrow, ______ I have seen yesterday and I love today.",
        "A": "so",
        "B": "and",
        "C": "for",
        "D": "but",
        "answer": "C"
    },
    {
        "year": 2017,
        "question": "Jim has retired, but he still remember the happy time _______ with his students.",
        "A": "to spend",
        "B": "spend",
        "C": "spending",
        "D": "spent",
        "answer": "D"
    },
    {
        "year": 2018,
        "question": "＿＿along the old Silk Road is an interesting and rewarding experience",
        "A": "Travel",
        "B": "Traveling",
        "C": "Having traveled",
        "D": "Traveled",
        "answer": "B"
    },
    {
        "year": 2019,
        "question": "We have entered into an age _____ dreams have the best chance of coming true. ",
        "A": "which",
        "B": "what",
        "C": "when",
        "D": "that",
        "answer": "C"
    },
    {
        "year": 2020,
        "question": "Grandma pointed to the hospital and said,'That's ______ I was born.'",
        "A": "when",
        "B": "how",
        "C": "why",
        "D": "where",
        "answer": "D"
    }
]